var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"pp-footer",class:{'pp-footer--fixed': _vm.fixed, 'color': _vm.color}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }